import { render, staticRenderFns } from "./PluginLayout.vue?vue&type=template&id=3a80e9cd&"
import script from "./PluginLayout.vue?vue&type=script&lang=js&"
export * from "./PluginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports